export const AIRPORT_FROM = 'airportFrom';
export const AIRPORT_TO   = 'airportTo';
